/**
 * AmendmentBanner — warning strip shown on the product edit page
 * (``/product-account/$id/edit``).
 *
 * Copy is intentionally explicit about the audit log so users understand
 * that this isn't a draft surface — every keystroke is a regulated edit.
 */
export function AmendmentBanner() {
  return (
    <div className="mb-6 bg-state-warning-bg border border-state-warning-border rounded-xl py-3 px-4 flex items-start gap-3">
      <div className="size-5 rounded-full bg-state-warning-accent text-white text-[12px] font-bold flex items-center justify-center shrink-0 mt-0.5">
        !
      </div>
      <div className="flex-1">
        <div className="font-semibold text-state-warning-text text-[14px]">
          You&rsquo;re amending a submitted product
        </div>
        <p className="text-[13px] text-state-warning-text/90 m-0 mt-0.5">
          Every change is recorded in the audit log with the field name, old
          value, and new value. The product stays submitted; there&rsquo;s
          no extra Submit step.
        </p>
      </div>
    </div>
  );
}
